import Axios from 'axios'
import { getCookie } from '../utils/auth-utils'

const authentication = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.AUTHENTICATION
    return AxiosInstance
  },
  isAuthenticated() {
    if (getCookie('token_aol') && getCookie('toggleAol')) {
      return true
    }
    return false
  },
  login(credentials) {
    let parameters = {
      idLab: credentials.idLab,
      username: credentials.username,
      password: credentials.password,
      grant_type: 'password'
    }

    return this.axios().post('/oauth/token', parameters)
  },
  newlogin(credentials) {
    let parameters = {
      idLab: credentials.idLab,
      username: credentials.username,
      password: credentials.password,
      grant_type: 'password'
    }

    return this.axios().post(`/authentication-api/auth/login?id-laboratory=${parameters.idLab}`, parameters)
  },
  refresh() {
    const refreshToken = getCookie('refresh_token_aol')
    return this.axios().post(`/authentication-api/auth/refresh?refresh=${refreshToken}`)
  },
  resetPassword(userData) {
    return this.axios().post('/authentication-api/password/recover', {
      labId: userData.labNumber,
      username: userData.email,
      cpf: userData.cpf
    })
  },
  changePassword(passData){
    return this.axios().post('/authentication-api/password/change', { password: passData.oldPassword, newPassword: passData.newPassword })
  }
}

export default authentication
